import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getBorder } from 'Components/utils';
import Splitter from 'Components/UI/Splitter';

const useStyles = buildUseStyles('NewMessageIndicator', ((theme) => ({
  root: {
    position: 'sticky',
    top: 56,
    zIndex: 20,
    ...getBorder(theme, { top: true, color: theme.palette.facet.orange }),
  },
  splitterTextPaper: {
    backgroundColor: theme.palette.facet.orange,
  },
  splitterTextText: {
    color: theme.palette.common.white,
  },
})));

const NewMessageIndicator = () => {
  const classes = useStyles();

  return (
    <Splitter
      showHorizontalRule
      classes={{
        root: classes.root,
        paper: classes.splitterTextPaper,
        text: classes.splitterTextText,
      }}
      text={'New'}
    />
  );
};

export default NewMessageIndicator;
